import React, { useContext } from 'react';
import { Box, Typography } from '@mui/material';
import { FormDataContext } from '../../contexts/FormDataContext';



export const Intro = () => {

  const {
    intakeIntroHeading,
    intakeIntroText,
  } = useContext(FormDataContext);

  return (
    <Box textAlign="center">
      <Typography
        variant="h2"
        component="h2"
        sx={{marginTop: '40px', marginBottom: '25px'}}
        dangerouslySetInnerHTML={{ __html: intakeIntroHeading }}
      />
      <Typography dangerouslySetInnerHTML={{ __html: intakeIntroText }}/>
    </Box>
  );
};